<template>
  <b-row v-if="formulas.length > 1">
    <b-col>
      <b-form-group label="Formula">
        <b-form-select v-model="formula" :options="options" class="mb-3" />
      </b-form-group>
    </b-col>
    <b-col v-if="availableSites.length == 1">
      <b-form-group label="Campionamento">
        <b-form-select v-model="sampling" class="mb-3">
        </b-form-select>
      </b-form-group>
    </b-col>
    <b-col v-if="addTags.length && availableSites.length > 1">
      <b-form-group label="Includi gruppi">
        <vue-tags-input
          v-model="addTagsModel"
          :tags="addTags.map(t => { return { text: t } })"
          @tags-changed="newTags => addTags = newTags.map( t => t.text )"
          :autocomplete-items="availableTags"
          :add-only-from-autocomplete="true"
          placeholder=""
        />
      </b-form-group>
    </b-col>
    <b-col v-if="addSites.length && availableSites.length > 1">
      <b-form-group label="Includi siti">
        <vue-tags-input
          v-model="addSiteModel"
          :tags="addSites.map(t => { return { text: t.name, guid: t.guid } })"
          @tags-changed="newTags => addSites = newTags.map( t => { return { name: t.text, guid: t.guid } }  )"
          :autocomplete-items="availableSites"
          :add-only-from-autocomplete="true"
          placeholder=""
        />
      </b-form-group>
    </b-col>
    <b-col v-if="excludeSites.length && availableSites.length > 1">
      <b-form-group label="Escludi siti">
        <vue-tags-input
          v-model="excludeSiteModel"
          :tags="excludeSites.map(t => { return { text: t.name, guid: t.guid } })"
          @tags-changed="newTags => excludeSites = newTags.map( t => { return { name: t.text, guid: t.guid } }  )"
          :autocomplete-items="availableSites"
          :add-only-from-autocomplete="true"
          placeholder=""
        />
      </b-form-group>
    </b-col>
    <b-col class="buttons-col">
      <b-form-group label="---">
        <b-button-toolbar>
          <b-button-group class="mx-1">
            <b-button @click="refreshData()" variant="primary" v-b-tooltip.hover title="Aggiorna">
              <font-awesome-icon icon="sync-alt" />
            </b-button>
            <b-button v-b-modal.saveModal variant="success" v-b-tooltip.hover title="Salva">
              <font-awesome-icon icon="plus" />
            </b-button>
          </b-button-group>
        </b-button-toolbar>
      </b-form-group>
    </b-col>

    <b-modal id="saveModal" ref="saveModal" title="Salva filtro">
      <div class="my-4">
        <div><strong>Formula:</strong> {{ formulaName }}</div>
        <div v-show="addTags.length && availableSites.length > 1"><strong>Gruppi:</strong> {{ addTags.join(", ") }}</div>
        <div v-show="addSites.length && availableSites.length > 1"><strong>Siti:</strong> {{ addSites.map(s => s.name).join(", ") }}</div>
        <div v-show="excludeSites.length && availableSites.length > 1"><strong>Siti esclusi:</strong> {{ excludeSites.map(s => s.name).join(", ") }}</div>
        <b-form-group class="mt-3" label="Nome">
          <b-input type="text" v-model="indicatorName" />
        </b-form-group>
        <b-alert variant="warning" :show="!indicatorName.length">
          <font-awesome-icon icon="exclamation-triangle" /> Inserire un nome
        </b-alert>
      </div>
      <div slot="modal-footer" class="w-100">
        <b-btn class="float-right ml-2" variant="success" @click="save">Salva</b-btn>
        <b-btn class="float-right" variant="warning" @click="closeSave">Annulla</b-btn>
      </div>
    </b-modal>
  </b-row>
</template>

<script>
import VueTagsInput from '@johmun/vue-tags-input'

export default {
  name: "IPGBar",
  props: ['refreshCallback', 'sites'],
  components: { VueTagsInput },

  created() {
    this.$store.dispatch('sites/tags', this.$store.state.user.customerGuid).then(data => {
      this.availableTags = data.map(t => { return { text: t } })
    })

    this.refresh()
  },

  methods: {
    refresh() {
      let data = {
        guid: this.customerGuid
      }
      this.$store.dispatch('indicators/formulas', data).then( (data) => {
        this.formulas = data
        this.options = [{ text: "-- seleziona --" }]
        data.forEach(f => {
          this.options.push({
            text: f.name,
            value: f.id
          })
        })
        if(this.options.length == 2) {
          this.formula = this.options[1].value
          this.refreshData()
        }
      })
    },
    refreshData() {
      if(! this.formula) {
        this.$notify({
          type: "error",
          text: "Selezionare una formula",
          title: 'Errore',
        });
        // this.$toasted.show('Selezionare una formula', { duration: 3000, icon : 'check', theme: "bubble" })
        return;
      }
      this.refreshCallback(this.formula, this.addTags, this.addSites, this.excludeSites, this.sampling)
    },
    closeSave() {
      this.$refs.saveModal.hide()
    },
    save() {
      if(! this.formula) {
        this.$notify({
          type: "error",
          text: "Selezionare una formula",
          title: 'Errore',
        });
        // this.$toasted.show('Selezionare una formula', { duration: 3000, icon : 'check', theme: "bubble" })
        return;
      }
      if(this.indicatorName.length) {
        let data = {
          formulaId: this.formula,
          name: this.indicatorName,
          tags: this.addTags,
          sites: this.addSites.map( s => s.guid),
          excludedSites: this.excludeSites.map( s => s.guid)
        }
        this.$store.dispatch('users/saveIndicator', data).then(response => {
          // this.$toasted.show('Indicatore aggiunto', { duration: 3000, icon : 'check', theme: "bubble" })
          this.$notify({
            type: "success",
            text: "Indicatore aggiunto",
            title: 'Successo'
          }); 

        })

        this.$refs.saveModal.hide()
      }
    }
  },

  computed: {
    customerGuid() {
      return this.$store.state.customerGuid
    },
    availableSites() {
      return this.$store.state.user.sites.map(s => { return { text: s.name, guid: s.guid } })
    },
    formulaName() {
      let _f = this.formulas.find(f => f.id == this.formula)
      if(_f)
        return _f.name

      return ""
    }
  },

  watch: {
    customerGuid(val) {
      this.refresh()
    }
  },

  data() {
    return {
      addTagsModel: '',
      addSiteModel: '',
      excludeSiteModel: '',
      options: [],
      addTags: [],
      addSites: [],
      excludeSites: [],
      formulas: [],
      formula: null,
      indicatorName: '',
      availableTags: [],
      sampling: '1'
    }
  }
}
</script>

<style>
.buttons-col {
  width:120px;
}
.buttons-col legend {
  visibility: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/IPG/IPGBar.vue